export const BRAND_PROFILES_ROUTES = [
  "brand-profiles",
  "brand-profiles-new",
  "brand-profiles-edit",
] as const;

export const PRODUCT_TABS = {
  crm: [
    "usage",
    "ratecard",
    "users",
    "team",
    "teams",
    "mention-streams",
    "social-streams",
    "brand-profiles",
    "distribution-list",
    "integrations",
    "metric-editor",
    "domains",
  ],
  dashboard: [
    "filter-sets",
    "usage",
    "ratecard",
    "users",
    "team",
    "teams",
    "mention-streams",
    "brand-profiles",
    "distribution-list",
    "integrations",
    "metric-editor",
    "domains",
  ],
  insights: [
    "usage",
    "ratecard",
    "users",
    "team",
    "teams",
    "mention-streams",
    "social-streams",
    "brand-profiles",
    "distribution-list",
    "integrations",
    "metric-editor",
    "domains",
  ],
  media: [
    "filter-sets",
    "query-snippets",
    "usage",
    "ratecard",
    "users",
    "team",
    "teams",
    "mention-streams",
    "brand-profiles",
    "distribution-list",
    "integrations",
    "metric-editor",
    "domains",
  ],
  outreach: [
    "usage",
    "brand-profiles",
    "users",
    "team",
    "teams",
    "integrations",
    "distribution-list",
    "domains",
  ],
  social: [
    "query-snippets",
    "usage",
    "users",
    "teams",
    "team",
    "social-streams",
    "brand-profiles",
    "integrations",
    "domains",
  ],
  web: [
    "usage",
    "ratecard",
    "users",
    "team",
    "teams",
    "integrations",
    "domains",
  ],
} as const;

export const PRODUCT_TAB_NAMES = Object.keys(
  PRODUCT_TABS
) as (keyof typeof PRODUCT_TABS)[];

export type OrganisationTabRoutes =
  | (typeof BRAND_PROFILES_ROUTES)[number]
  | (typeof PRODUCT_TABS)["dashboard"][number]
  | (typeof PRODUCT_TABS)["web"][number]
  | (typeof PRODUCT_TABS)["media"][number]
  | (typeof PRODUCT_TABS)["social"][number]
  | (typeof PRODUCT_TABS)["outreach"][number];
